export class User {
  active: boolean;
  email: string;
  firstName: string;
  company: string;
  idAdmin: number;
  lastName: string;
  password: string;
  refreshToken: string;
  userName: string;
  accessToken: string;
  role: string;

    constructor(params: any) {
        this.accessToken = params.accessToken;
        this.idAdmin = params.idAdmin;
        this.firstName = params.firstName;
        this.company = params.company;
        this.lastName = params.lastName;
        this.refreshToken = params.refreshToken;
        this.userName = params.userName;
        this.role = params.role;
        this.email = params.email;
        this.active = params.active;
    }
}
